export const GET_FEATURED_ITEMS = "GET_FEATURED_ITEMS";
export const ADD_FEATURED_ITEM = "ADD_FEATURED_ITEM";
export const DELETE_FEATURED_ITEM = "DELETE_FEATURED_ITEM";
export const UPDATE_FEATURED_ITEM = "UPDATE_FEATURED_ITEM";
export const FEATURED_ITEMS_LOADING = "FEATURED_ITEMS_LOADING";
export const FEATURED_ITEMS_ERROR = "FEATURED_ITEMS_ERROR";
